// Author Lin
// Date 2021-10-03 15:25:13

import * as model from "@/model/mintalMes/mst/MintalMesMstFurnaceModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.MintalMesMstFurnace(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_MINTALMES_MST_URL,
    })
    .buildStore()
